import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InventurEintrag } from '../entities/InventurEintrag';

@Component({
    selector: 'kiene-inventur-delete-dialog',
    templateUrl: './inventur-delete-dialog.component.html',
    styleUrls: ['./inventur-delete-dialog.component.scss'],
})
export class InventurDeleteDialogComponent implements OnInit {
    inventurEintrag: InventurEintrag;

    constructor(
        public dialogRef: MatDialogRef<InventurDeleteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data,
    ) {}

    ngOnInit(): void {
        this.inventurEintrag = this.data.inventurEintrag;
    }
    close() {
        this.dialogRef.close(false);
    }

    save() {
        this.dialogRef.close(true);
    }
}
